import { TableCell, Typography } from "@material-ui/core";
import { useStyles } from "./styles";
import { Alert } from "@material-ui/lab";

export const TrackerRowCell = (data: number, type: string, secondData?: number) => {
  const classes = useStyles();

  switch (type) {
    case "availability":
    case "shifts":
      const cond = data >= 4;
      return (
        <TableCell className={`${classes.tableCell} ${classes.leftBorderCell}`}>
          <Alert
            icon={false}
            severity={cond ? "success" : "error"}
            className={cond ? classes.greenAlert : classes.redAlert}
            style={{ padding: "0 5px", display: "flex", justifyContent: "center" }}
          >
            <Typography variant="body2">{data}</Typography>
          </Alert>
        </TableCell>
      );
    case "confirmed":
      const confirmedCond = data === secondData;
      return (
        <TableCell className={`${classes.tableCell} ${classes.leftBorderCell}`}>
          <Alert
            icon={false}
            severity={confirmedCond ? "success" : "error"}
            className={confirmedCond ? classes.greenAlert : classes.redAlert}
            style={{ padding: "0 5px", display: "flex", justifyContent: "center" }}
          >
            <Typography variant="body2">{data}</Typography>
          </Alert>
        </TableCell>
      );
    case "rejected":
      const rejectedCond = data === 1 ? "warning" : data >= 2 ? "error" : "success";
      const rejectedClass =
        data === 1 ? classes.yellowAlert : data >= 2 ? classes.redAlert : classes.greenAlert;
      return (
        <TableCell className={`${classes.tableCell} ${classes.leftBorderCell}`}>
          <Alert
            icon={false}
            severity={rejectedCond}
            className={rejectedClass}
            style={{ padding: "0 5px", display: "flex", justifyContent: "center" }}
          >
            <Typography variant="body2">{data}</Typography>
          </Alert>
        </TableCell>
      );
    case "client_cancelled":
      const cancelledCond = data === 1 ? "warning" : data >= 2 ? "error" : "success";
      const cancelledClass =
        data === 1 ? classes.yellowAlert : data >= 2 ? classes.redAlert : classes.greenAlert;
      return (
        <TableCell className={`${classes.tableCell} ${classes.leftBorderCell}`}>
          <Alert
            icon={false}
            severity={cancelledCond}
            className={cancelledClass}
            style={{ padding: "0 5px", display: "flex", justifyContent: "center" }}
          >
            <Typography variant="body2">{data}</Typography>
          </Alert>
        </TableCell>
      );
    case "mycu_cancelled":
      const mycuCancelledCond = data === 1 ? "warning" : data >= 2 ? "error" : "success";
      const mycuCancelledClass =
        data === 1 ? classes.yellowAlert : data >= 2 ? classes.redAlert : classes.greenAlert;
      return (
        <TableCell className={`${classes.tableCell} ${classes.leftBorderCell}`}>
          <Alert
            icon={false}
            severity={mycuCancelledCond}
            className={mycuCancelledClass}
            style={{ padding: "0 5px", display: "flex", justifyContent: "center" }}
          >
            <Typography variant="body2">{data}</Typography>
          </Alert>
        </TableCell>
      );
  }
};
